/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBookingSlotsQueryResponse, GetApiBookingSlotsQueryParams } from "../entities/GetApiBookingSlots";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBookingSlots } from "../api/getApiBookingSlots";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBookingSlotsQueryKey = (params: GetApiBookingSlotsQueryParams) => [{ url: '/api/booking/slots' }, ...(params ? [params] : [])] as const

export type GetApiBookingSlotsQueryKey = ReturnType<typeof getApiBookingSlotsQueryKey>

export function getApiBookingSlotsQueryOptions(params: GetApiBookingSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBookingSlotsQueryKey(params)
        return queryOptions<GetApiBookingSlotsQueryResponse, ResponseErrorConfig<Error>, GetApiBookingSlotsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBookingSlots(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить список доступных слотов 30 минут
 * @summary Получить доступные слоты
 * {@link /api/booking/slots}
 */
export function useGetApiBookingSlots<TData = GetApiBookingSlotsQueryResponse, TQueryData = GetApiBookingSlotsQueryResponse, TQueryKey extends QueryKey = GetApiBookingSlotsQueryKey>(params: GetApiBookingSlotsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBookingSlotsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBookingSlotsQueryKey(params)
         

         const query = useQuery({
          ...getApiBookingSlotsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}